import type * as React from 'react';
import { cn } from '../lib/cn.js';

/** 16 px sous le seuil `md` : le corps est à 14 px, et un champ plus petit fait zoomer iOS au focus. */
export function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
  return (
    <textarea
      className={cn(
        'flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-[16px] shadow-2xs transition-[border-color,box-shadow] duration-150 placeholder:text-muted-foreground/80 focus-visible:outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/20 aria-[invalid=true]:border-destructive disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        className,
      )}
      {...props}
    />
  );
}
